import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-tab-bar WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, TabBarWebElement.ts.
 */
export class TabBarWebElementBase extends OjWebElement {
  /**
   * Gets the value of <code>data</code> property.
   * An array of tabs
   * @return The value of <code>data</code> property.
   *
   */
  public getData(): Promise<Array<object>> {
    return this.getProperty<Array<object>>('data');
  }

  /**
   * Sets the value of <code>selection</code> property.
   * The key of the selected tab
   * @param selection The value to set for <code>selection</code>
   *
   */
  public changeSelection(selection: string | number): Promise<void> {
    return this.setProperty<string | number>('selection', selection);
  }

  /**
   * Gets the value of <code>selection</code> property.
   * The key of the selected tab
   * @return The value of <code>selection</code> property.
   *
   */
  public getSelection(): Promise<string | number> {
    return this.getProperty<string | number>('selection');
  }

  /**
   * Gets the value of <code>reorderable</code> property.
   * The reorderable configuration for tabs.
   * @return The value of <code>reorderable</code> property.
   *
   */
  public getReorderable(): Promise<string> {
    return this.getProperty<string>('reorderable');
  }

  /**
   * Gets the value of <code>overflow</code> property.
   * Specifies the overflow behavior.
   * @return The value of <code>overflow</code> property.
   *
   */
  public getOverflow(): Promise<string> {
    return this.getProperty<string>('overflow');
  }

  /**
   * Gets the value of <code>display</code> property.
   * The display configuration for tabs.
   * @return The value of <code>display</code> property.
   *
   */
  public getDisplay(): Promise<string> {
    return this.getProperty<string>('display');
  }

  /**
   * Gets the value of <code>layout</code> property.
   * The layout configuration for tabs.
   * @return The value of <code>layout</code> property.
   *
   */
  public getLayout(): Promise<string> {
    return this.getProperty<string>('layout');
  }

  /**
   * Gets the value of <code>edge</code> property.
   * The edge configuration for tabs.
   * @return The value of <code>edge</code> property.
   *
   */
  public getEdge(): Promise<string> {
    return this.getProperty<string>('edge');
  }

  /**
   * Gets the value of <code>truncation</code> property.
   * The truncation configuration for tab labels.
   * @return The value of <code>truncation</code> property.
   *
   */
  public getTruncation(): Promise<string> {
    return this.getProperty<string>('truncation');
  }

  /**
   * Gets the value of <code>contextMenuConfig</code> property.
   * Specifies a context menu configuration.
   * @return The value of <code>contextMenuConfig</code> property.
   *
   */
  public getContextMenuConfig(): Promise<ContextMenuConfig> {
    return this.getProperty<ContextMenuConfig>('contextMenuConfig');
  }
}
export interface ContextMenuConfig {
  /**
   *
   */
  accessibleLabel: string;
}
